import Cookie from 'js-cookie'
import { settings } from '../../main/configs/settings'

export const clearStorage = () => {
  localStorage.clear()
  const exceptions = ['teamUUId', 'gameUUId']

  Object.keys(sessionStorage).forEach((item) => {
    if (!item.includes('utm')) sessionStorage.removeItem(item)
  })

  Object.keys(Cookie.get()).forEach((item) => {
    if (!exceptions.includes(item)) {
      Cookie.remove(item)
    }
  })

  Cookie.remove(settings.TOKEN as string, {
    domain: settings.DOMAIN
  })
}

export const clearSignupCodes = () => {
  Cookie.remove('gameUUId' as string, {
    domain: settings.DOMAIN
  })
  Cookie.remove('teamUUId' as string, {
    domain: settings.DOMAIN
  })
  Cookie.remove('gameUUId' as string, {
    domain: 'localhost'
  })
  Cookie.remove('teamUUId' as string, {
    domain: 'localhost'
  })
}
